// src/api/services.js
import client from './client';

export const authAPI = {
  login:          (data) => client.post('/auth/login', data),
  register:       (data) => client.post('/auth/register', data),
  refresh:        (token) => client.post('/auth/refresh', { refreshToken: token }),
  me:             () => client.get('/auth/me'),
  changePassword: (data) => client.put('/auth/change-password', data),
};

export const farmAPI = {
  dashboard:  (farmId) => client.get('/farm/dashboard', { params: { farm_id: farmId } }),
  pens:       (farmId) => client.get('/farm/pens',      { params: { farm_id: farmId } }),
  addPen:     (data)   => client.post('/farm/pens', data),
  info:       (farmId) => client.get('/farm/info',      { params: { farm_id: farmId } }),
  updateInfo: (id,data)=> client.put(`/farm/info/${id}`, data),
};

export const animalsAPI = {
  list:      (params) => client.get('/animals', { params }),
  get:       (id)     => client.get(`/animals/${id}`),
  create:    (data)   => client.post('/animals', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update:    (id, data) => client.put(`/animals/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete:    (id)     => client.delete(`/animals/${id}`),
  logWeight: (id, data) => client.post(`/animals/${id}/weight`, data),
  weightHistory: (id) => client.get(`/animals/${id}/weights`),
  species:   ()       => client.get('/animals/lookup/species'),
  breeds:    (speciesId) => client.get('/animals/lookup/breeds', {
    params: { species_id: speciesId },
  }),
  // Get all active animals for dropdowns (lightweight)
  dropdown:  (params) => client.get('/animals/lookup/dropdown', { params }),
};

export const feedsAPI = {
  list:       (params) => client.get('/feeds', { params }),
  get:        (id)     => client.get(`/feeds/${id}`),
  create:     (data)   => client.post('/feeds', data),
  update:     (id,data)=> client.put(`/feeds/${id}`, data),
  restock:    (id,data)=> client.post(`/feeds/${id}/restock`, data),
  logUsage:   (data)   => client.post('/feeds/usage', data),
  schedules:  (farmId) => client.get('/feeds/schedules', { params: { farm_id: farmId } }),
  addSchedule:(data)   => client.post('/feeds/schedules', data),
};

export const healthAPI = {
  list:         (params) => client.get('/health', { params }),
  get:          (id)     => client.get(`/health/${id}`),
  create:       (data)   => client.post('/health', data),
  update:       (id,data)=> client.put(`/health/${id}`, data),
  delete:       (id)     => client.delete(`/health/${id}`),
  vaccinations: (params) => client.get('/health/vaccinations', { params }),
  vaccinate:    (data)   => client.post('/health/vaccinations', data),
  vaccines:     ()       => client.get('/health/vaccines'),
  vets:         ()       => client.get('/health/vets'),
  addVet:       (data)   => client.post('/health/vets', data),
};

export const breedingAPI = {
  list:        (params)    => client.get('/breeding', { params }),
  create:      (data)      => client.post('/breeding', data),
  recordBirth: (id, data)  => client.post(`/breeding/${id}/birth`, data),
  upcoming:    ()          => client.get('/breeding/upcoming'),
};

export const financeAPI = {
  dashboard:  (farmId)  => client.get('/finance/dashboard', { params: { farm_id: farmId } }),
  expenses:   (params)  => client.get('/finance/expenses', { params }),
  addExpense: (data)    => client.post('/finance/expenses', data),
  sales:      (params)  => client.get('/finance/sales', { params }),
  recordSale: (data)    => client.post('/finance/sales', data),
  revenue:    (params)  => client.get('/finance/revenue', { params }),
  addRevenue: (data)    => client.post('/finance/revenue', data),
  categories: (farmId)  => client.get('/finance/categories', { params: { farm_id: farmId } }),
};

export const usersAPI = {
  list:   ()         => client.get('/users'),
  get:    (id)       => client.get(`/users/${id}`),
  update: (id, data) => client.put(`/users/${id}`, data),
  toggle: (id, data) => client.put(`/users/${id}/activate`, data),
  roles:  ()         => client.get('/users/roles'),
};